module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-4032-68eee85b0dd42bcaba1d35afaa2419e1.webp";